import CityPageTemplate from "../city-template/CityPageTemplate";
import { alamogordoConfig } from "./data";

export default function AlamogordoPage() {
  return <CityPageTemplate config={alamogordoConfig} />;
}